module.exports = __webpack_public_path__ + "img/dry-hairy-tree-02.32f7e3c7.png";